/**
 * @props color: to set the colour of bagde
 * @props headerType: to change the size of the badge 
 * @props pill: to add border radius to the badge
 * @props bodyText: text inside badge
 */

import React from 'react'
import Heading from '../heading/Heading'
import { HEADING } from '../heading/constants/constants'
import { Badge } from 'reactstrap'

const TxBadge = ({
    color = "primary",
    headerType = HEADING.H2,
    pill = true,
    bodyText = ""
}) => {
    return (

        <Heading type={headerType} customStyle={{ display: "inline-block" }}>
            <Badge color={color} pill={pill}>{bodyText}</Badge>
        </Heading>
    )
}

export default TxBadge
